/**
 * Panel definitions for flex/capturePrice segment.
 *
 * Surfaces the NED Capture Price chart (forecast / actual / realised).
 * Backend dataset: `profiteia-capture-price`.
 */

export const flexCapturePricePanels = [
  {
    id: 'capture-price-solar-nl',
    type: 'datasetChart',
    datasetId: 'profiteia-capture-price',
    visualizationId: 'ned-capture-price-chart',
    gridPos: { x: 0, y: 0, w: 24, h: 16 },
  },
];
